import apiClientCoinGecko from '../Api/ApiClientCoinGecko';
import apiNameCoinGecko from '../Api/ApiNameCoinGecko.json';


//gọi api coin/market
export const callAPiCoinMarket = (param={}) => {
    return apiClientCoinGecko.get(apiNameCoinGecko.coin_market,{
        params:{
            ...param,
            "price_change_percentage":"1h,24h,7d",
            "sparkline":true
        }
    })
} 